module.exports = __webpack_public_path__ + "img/stena33.bf710505.jpg";